import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import type { MenuItem } from "primeng/api";
import * as FlatModels from "@medsurf/flat-models";
import { AlertControlFacade, NodeSharedFacade, SlideAuthorFacade } from "@medsurf/flat-facades";

@Component({
    selector: 'medsurf-slide-wysiwyg',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './wysiwyg.component.html',
    styleUrls: ['./wysiwyg.component.scss'],
    standalone: false
})
export class WysiwygComponent {
  questionsMenuItems: MenuItem[] = [
    {
      label: this.translate.instant('global.question_add'),
      disabled: true,
      styleClass: 'menu_grouping_label',
    },
    {
      label: this.translate.instant('enum.question.LongListQuestion'),
      icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION_LONG_LIST,
      command: () => this.#addQuestion(FlatModels.QuestionEntityModels.QuestionType.enum.LongListQuestion),
    },
    {
      label: this.translate.instant('enum.question.TrueFalseQuestion'),
      icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION_TRUE_FALSE,
      command: () => this.#addQuestion(FlatModels.QuestionEntityModels.QuestionType.enum.TrueFalseQuestion),
    },
    {
      label: this.translate.instant('enum.question.FreeTextQuestion'),
      icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION_FREE_TEXT,
      command: () => this.#addQuestion(FlatModels.QuestionEntityModels.QuestionType.enum.FreeTextQuestion),
    },
    {
      label: this.translate.instant('enum.question.IndicationQuestion'),
      icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION_INDICATION,
      command: () => this.#addQuestion(FlatModels.QuestionEntityModels.QuestionType.enum.IndicationQuestion),
    },
    {
      label: this.translate.instant('enum.question.MappingQuestion'),
      icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION_MAPPING,
      command: () => this.#addQuestion(FlatModels.QuestionEntityModels.QuestionType.enum.MappingQuestion),
    },
  ];
  readonly FlatModels = FlatModels;
  
  constructor(public nodeSharedFacade: NodeSharedFacade,
              public slideAuthorFacade: SlideAuthorFacade,
              private alertControlFacade: AlertControlFacade,
              private translate: TranslateService) {
  }

  #addQuestion(questionType: FlatModels.QuestionEntityModels.QuestionType) {
    const pageClone = structuredClone(this.slideAuthorFacade.snapshot_page()) as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training;
    this.slideAuthorFacade.requestAddQuestion(pageClone, questionType).subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result)
    });
  }
}
